const WAVE_PATH_1 = "M0,42 C240,88 480,4 720,36 C960,68 1200,18 1440,46 L1440,90 L0,90 Z";
const WAVE_PATH_2 = "M0,58 C240,22 480,82 720,52 C960,26 1200,72 1440,52 L1440,90 L0,90 Z";

function WaveSvg({ fill }) {
    return (
        <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className="w-1/2 h-[56px] md:h-[84px] shrink-0">
            <path d={WAVE_PATH_1} fill={fill} opacity="0.45" />
            <path d={WAVE_PATH_2} fill={fill} />
        </svg>
    );
}

export default function WaveDivider({ fill = "#020D18", testid }) {
    return (
        <div className="w-full overflow-hidden leading-none" aria-hidden="true" data-testid={testid}>
            <div className="wave-drift flex w-[200%] will-change-transform">
                <WaveSvg fill={fill} />
                <WaveSvg fill={fill} />
            </div>
        </div>
    );
}
